import React from "react";
import {
  Button,
  Circle,
  SimpleGrid,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Spacer,
  Text
} from "@chakra-ui/react";
import { ColumnInstance, Filters } from "react-table";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";

interface Props {
  columns: ColumnInstance[];
  filters: Filters<any>;
}

const FilterDropdown: React.FC<Props> = ({ columns, filters }: Props) => {
  const filterable = columns.filter(col => col.Filter && !col.disableFilters);
  if (filterable.length <= 0) return null;
  return (
    <Popover placement="bottom-end">
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <Button
              size="sm"
              variant="dark"
              rounded="lg"
              leftIcon={
                <Icon
                  as={isOpen ? AiFillCaretUp : AiFillCaretDown}
                  color="blue.500"
                  w={6}
                  h={6}
                />
              }
              rightIcon={
                filters.length > 0 ? (
                  <Circle centerContent size="25px" bgColor="blue.500">
                    <Text fontWeight="medium" color="gray.900">
                      {filters.length}
                    </Text>
                  </Circle>
                ) : undefined
              }
            >
              Filters
              <Spacer />
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverBody>
              <SimpleGrid columns={2} spacing={'25px'}>
                {filterable.map(column => (
                  <div key={column.id}>{column.render("Filter")}</div>
                ))}
              </SimpleGrid>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default FilterDropdown;
